<template>
  <div class="content">
    <div class="mod">
      <div class="box">
        <div class="bd">
          <div class="list">
            <img class="layer" src="static/img/女神节.jpg" data-src="static/img/女神节.jpg" alt="layer"/>
            <div class="row1">
              <img class="largeIcon" src="static/img/按摩仪.png" data-src="static/img/按摩仪.png" alt="largeIcon"/>
              <div class="outer_2">
                <div class="wrap">
                  <span class="text_2">PGG</span>
                  <span class="txt">颈椎按摩器</span>
                </div>
                <span class="desc">礼品将在回款后为您寄出</span>
              </div>
              <img v-if="receive1 === false" @click="receivePrize(1)" class="largeIcon_1 icon" src="static/img/领取.png" data-src="static/img/领取.png" alt="largeIcon_1 icon">
              <img v-if="receive1 === true" class="largeIcon_1 icon" src="static/img/已领取.png" data-src="static/img/已领取.png" alt="largeIcon_1">
              <img v-if="grey1 === true" class="largeIcon_1 icon" src="static/img/领取灰.png" data-src="static/img/领取灰.png" alt="largeIcon_1">
            </div>
            <div class="row2">
              <img class="largeIcon_2" src="static/img/保温杯.png" data-src="static/img/保温杯.png" alt="largeIcon_2"/>
              <div class="outer_2">
                <div class="wrap">
                  <span class="text_2">特美刻</span>
                  <span class="txt">智能保温杯</span>
                </div>
                <span class="desc">礼品将在回款后为您寄出</span>
              </div>
              <img v-if="receive2 === false" @click="receivePrize(2)" class="largeIcon_1 icon" src="static/img/领取.png" data-src="static/img/领取.png" alt="largeIcon_1">
              <img v-if="receive2 === true" class="largeIcon_1 icon" src="static/img/已领取.png" data-src="static/img/已领取.png" alt="largeIcon_1">
              <img v-if="grey2 === true" class="largeIcon_1 icon" src="static/img/领取灰.png" data-src="static/img/领取灰.png" alt="largeIcon_1">
            </div>
            <div class="row3">
              <div class="container_3">
                <img class="largeIcon_3" src="static/img/台灯.png" data-src="static/img/台灯.png" alt="largeIcon_3"/>
              </div>
              <div class="outer_3">
                <div class="group_4">
                  <span class="txt_2">华为智选</span>
                  <span class="word_3">智能台灯</span>
                </div>
                <span class="desc_3">礼品将在回款后为您寄出</span>
              </div>
              <img v-if="receive3 === false" @click="receivePrize(3)" class="largeIcon_1 icon" src="static/img/领取.png" data-src="static/img/领取.png" alt="largeIcon_1">
              <img v-if="receive3 === true" class="largeIcon_1 icon" src="static/img/已领取.png" data-src="static/img/已领取.png" alt="largeIcon_1">
              <img v-if="grey3 === true" class="largeIcon_1 icon" src="static/img/领取灰.png" data-src="static/img/领取灰.png" alt="largeIcon_1">
            </div>
            <div class="row4">
              <div class="block_6">
                <img class="largeIcon_4" src="static/img/三只松鼠.png" data-src="static/img/三只松鼠.png" alt="largeIcon_4"/>
              </div>
              <div class="outer_4">
                <div class="group_4">
                  <span class="txt_2">三只松鼠</span>
                  <span class="word_3">坚果礼包</span>
                </div>
                <span class="desc_3">礼品将在回款后为您寄出</span>
              </div>
              <img v-if="receive4 === false" @click="receivePrize(4)" class="largeIcon_1 icon" src="static/img/领取.png" data-src="static/img/领取.png" alt="largeIcon_1">
              <img v-if="receive4 === true" class="largeIcon_1 icon" src="static/img/已领取.png" data-src="static/img/已领取.png" alt="largeIcon_1">
              <img v-if="grey4 === true" class="largeIcon_1 icon" src="static/img/领取灰.png" data-src="static/img/领取灰.png" alt="largeIcon_1">
            </div>
          </div>
          <div class="item">
            <span class="text_6">活动说明</span>
            <span class="article">
              1、下单成功后可进行礼品选择，每个账户限参与一次，礼品将在订单回款后5个工作日后安排寄送；<br>
              2、扩增合同，血清和冰盒产品不参与本次活动，其他产品都参加；<br>
              3、该折扣优惠与其他优惠券和会员折扣不同享。
            </span>
          </div>
          <div class="group_6">
            <div class="tagWrap">
              <span class="tag" @click="goHome">
                返回首页
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import Emkt from '../../emkt'
  import wx from 'wx'
  import $ from 'jquery'

  export default {
    mounted () {
    },
    computed: {
      ...mapState([
        'sessionInfo', 'myOrder', 'showLotteryAlready'
      ]),
      ...mapGetters([
        'hasLogin', 'customerName'
      ])
    },
    data () {
      return {
        receive1: false,
        receive2: false,
        receive3: false,
        receive4: false,
        grey1: false,
        grey2: false,
        grey3: false,
        grey4: false,
        prizes: {
          1: {
            name: 'PGG颈椎按摩器',
            type: Emkt.PRIZE_TYPE_OBJECT
          },
          2: {
            name: '特美刻智能保温杯',
            type: Emkt.PRIZE_TYPE_OBJECT
          },
          3: {
            name: '华为智选智能台灯',
            type: Emkt.PRIZE_TYPE_OBJECT
          },
          4: {
            name: '三只松鼠坚果礼盒',
            type: Emkt.PRIZE_TYPE_OBJECT
          }
        },
        PrizeDetailBO: {}
      }
    },
    methods: {
      goHome () {
        if (this.receive1 === false && this.receive2 === false && this.receive3 === false && this.receive4 === false) {
          this.$weui.dialog({
            title: '',
            content: '您确定放弃领取奖品吗',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.revert()
              }
            }]
          })
        } else {
          this.revert()
        }
      },
      revert () {
        if (Emkt.isWapp) {
          wx.miniProgram.switchTab({
            url: '/pages/index/index'
          })
        } else {
          this.$router.replace({ name: 'home' })
        }
      },
      receivePrize (id) {
        if (id === 1) {
          this.$weui.dialog({
            title: '「是否确认领取礼品？」',
            content: 'PGG颈椎按摩器，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.subLottery(id)
              }
            }]
          })
        } else if (id === 2) {
          this.$weui.dialog({
            title: '「是否确认领取礼品？」',
            content: '特美刻智能保温杯，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.subLottery(id)
              }
            }]
          })
        } else if (id === 3) {
          this.$weui.dialog({
            title: '「是否确认领取礼品？」',
            content: '华为智选智能台灯，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.subLottery(id)
              }
            }]
          })
        } else {
          this.$weui.dialog({
            title: '「是否确认领取礼品？」',
            content: '三只松鼠坚果礼盒，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.subLottery(id)
              }
            }]
          })
        }
      },
      subLottery (id) {
        var _this = this
        var objectPrizes = []
        const selectedPrize = _this.prizes[id]
        if (selectedPrize.type === Emkt.PRIZE_TYPE_OBJECT) {
          objectPrizes.push(selectedPrize.name)
          _this.PrizeDetailBO = {
            'orderId': _this.$route.query.BOrders[0].id,
            'activityName': Emkt.activityName,
            'promotionGuid': Emkt.promotionGuid,
            'objectPrizes': objectPrizes
          }
        }
        _this.gcapi('checkCustomerAlreadyRequestPrize', this.PrizeDetailBO).then((response) => {
          if (response.body.result === true) {
            $.toast('守护礼活动每个账户限参与一次')
          } else {
            _this.gcapi('requestPrize', this.PrizeDetailBO).then((response) => {
              if (response.body.result === true) {
                if (id === 1) {
                  _this.receive1 = true
                  _this.grey2 = true
                  _this.grey3 = true
                  _this.grey4 = true
                } else if (id === 2) {
                  _this.receive2 = true
                  _this.grey1 = true
                  _this.grey3 = true
                  _this.grey4 = true
                } else if (id === 3) {
                  _this.receive3 = true
                  _this.grey1 = true
                  _this.grey2 = true
                  _this.grey4 = true
                } else {
                  _this.receive4 = true
                  _this.grey1 = true
                  _this.grey2 = true
                  _this.grey3 = true
                }
              }
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
  .mod {
    width: 100%;
    height: 1154px;
  }
  .mod .box {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    background-color: #FECCDA;
    width: 100%;
    height: 1154px;
    overflow: hidden;
  }
  .mod .bd {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    background-image: linear-gradient(180deg, #FFDAE4 0%, #FEC2D3 100%);
    width: 100%;
    height: 1154px;
  }
  .mod .list {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    margin-top: 20px;
    width: 100%;
    height: 667px;
    padding: 0px 10px;
  }
  .mod .layer {
    position: absolute;
    top: 0px;
    align-self: center;
    width: 335px;
    height: 667px;
  }
  .mod .row1 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 228px;
    border-radius: 10px;
    background-color: #FFEEDD;
    width: 285px;
    height: 75px;
  }
  .mod .icon {
    position: absolute;
    right: 11px;
  }
  .mod .largeIcon {
    margin-right: 5px;
    margin-left: 5px;
    width: 68px;
    height: 65px
  }
  .mod .outer_2 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    height: 37px;
    margin-right: 22px;
  }
  .mod .wrap {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    height: 21px;
  }
  .mod .text_2 {
    line-height: 21px;
    color: #6c4c39;
    font-size: 15px;
    font-weight: 500;
  }
  .mod .txt {
    line-height: 21px;
    color: #e04626;
    font-size: 15px;
    font-weight: 500;
  }
  .mod .desc {
    position: relative;
    max-width: 195px;
    height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 16px;
    color: #6c4c39;
    font-size: 11px;
    font-weight: 400;
  }
  .mod .row2 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 30px;
    border-radius: 10px;
    background-color: #FFEEDD;
    width: 285px;
    height: 75px;
  }
  .mod .largeIcon_1 {
    width: 53px;
    height: 53px;
  }
  .mod .largeIcon_2 {
    margin-right: 5px;
    margin-left: 5px;
    width: 68px;
    height: 65px;
  }
  .mod .row3 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 30px;
    border-radius: 10px;
    background-color: #FFEEDD;
    width: 285px;
    height: 75px;
  }
  .mod .container_3 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-right: 5px;
    margin-left: 5px;
    background-color: rgba(216, 216, 216, 0.00);
    width: 68px;
    height: 65px;
    overflow: hidden;
  }
  .mod .largeIcon_3 {
    width: 56px;
    height: 56px;
    margin: 6px 6px 5px 4px;
  }
  .mod .outer_3 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    height: 38px;
    margin-right: 8px;
  }
  .mod .outer_4 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    height: 38px;
    margin-right: 26px;
  }
  .mod .group_4 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    height: 21px;
  }
  .mod .txt_2 {
    line-height: 21px;
    color: #6c4c39;
    font-size: 15px;
    font-weight: 500;
  }
  .mod .word_3 {
    line-height: 21px;
    color: #e04626;
    font-size: 15px;
    font-weight: 500;
  }
  .mod .desc_3 {
    position: relative;
    margin-top: 1px;
    line-height: 16px;
    color: #6c4c39;
    font-size: 11px;
    font-weight: 400;
  }
  .mod .row4 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 30px;
    border-radius: 10px;
    background-color: #FFEEDD;
    width: 285px;
    height: 75px;
  }
  .mod .block_6 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-right: 5px;
    margin-left: 5px;
    background-color: rgba(216, 216, 216, 0.00);
    width: 68px;
    height: 65px;
    overflow: hidden;
  }
  .mod .largeIcon_4 {
    width: 68px;
    height: 63px;
  }
  .mod .item {
    align-items: center;
    max-width: 341px;
    width: 300px;
    margin: 0 auto;
    margin-top: -20px;
  }
  .mod .text_6 {
    position: relative;
    margin-top: 35px;
    max-width: 341px;
    height: 17px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 17px;
    color: #6c4c39;
    font-size: 12px;
    font-weight: 400;
    display: inline-block;
  }
  .mod .article {
    margin-top: 10px;
    width: 312px;
    line-height: 20px;
    color: #6c4c39;
    font-size: 12px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    height: 235px;
    display: inline-block;
  }
  .mod .group_6 {
    box-shadow: 0 -2px 20px 0 rgba(0, 0, 0, 0.10);
    display: flex;
    position: fixed;
    align-items: center;
    flex-direction: column;
    margin-top: 120px;
    background-color: #FEC2D3;
    width: 100%;
    height: 96px;
    bottom: 0;
  }
  .mod .tagWrap {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 15px;
    border-radius: 22px;
    background-image: linear-gradient(90deg, #FEA5BF 0%, #FEA5BF 100%);
    width: 355px;
    height: 44px;
  }
  .mod .tag {
    max-width: 343px;
    height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }
</style>




// WEBPACK FOOTER //
// SuccessPay4.vue?4f36e350